/** @jsx jsx */
import { jsx } from '@emotion/react';
import { colors, fancyBorder } from '../../theme';
import { PropertyInfo } from './PropertiesTable';
import commandsSchema from '../../../@generated/current-cli-schema.json';

type CommandArg = {
  name: string;
  required: boolean;
  description: string;
  alias?: string;
  allowedValues: string[];
  allowedTypes: string[];
};

const CliCommandsApiReference = ({ command, sortedArgs }: { command: string; sortedArgs: CommandArg[] }) => {
  return (
    <div
      id={`api-ref-${command}`}
      css={{
        ...fancyBorder,
        background: colors.background,
        marginBottom: '15px',
        marginTop: '12px'
      }}
    >
      <div
        css={{
          display: 'flex',
          padding: '12px',
          background: colors.darkerBackground,
          color: colors.primary,
          fontWeight: 'bold',
          fontSize: '14px'
        }}
      >
        <div css={{ textAlign: 'left', width: '50%' }}>Command options API reference</div>
      </div>
      <div>
        {Object.keys(commandsSchema[command].args).length ? (
          sortedArgs.map(({ name, required, description, alias, allowedValues, allowedTypes }, idx) => {
            return (
              <PropertyInfo
                key={name}
                propertyName={`${name} (--${alias})`}
                idx={idx}
                propertyRequired={required}
                shortDescription={description}
                longDescription={null}
                propertyTypeInfo={{
                  allowedTypes: [{ typeName: allowedTypes[0], enumeratedValues: allowedValues }],
                  isArray: false
                }}
              />
            );
          })
        ) : (
          <p css={{ padding: '10px' }}>No available options.</p>
        )}
      </div>
    </div>
  );
};

export default CliCommandsApiReference;
